module.exports = __webpack_public_path__ + "img/fid_ux.04fd8895.svg";